import SendIcon from "@mui/icons-material/Send";
import type { FC } from "react";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import { useCustomerEmails } from "../../orders/emails/useCustomerEmails";

const SendCheckInButton: FC<{ orderId: string }> = ({ orderId }) => {
  const { sendEmail } = useCustomerEmails(orderId);
  return (
    <AsyncLoadingButton
      startIcon={<SendIcon />}
      variant="outlined"
      color="primary"
      sx={{ width: { xs: "100%", sm: "auto" } }}
      onClick={async () => {
        await sendEmail("CHECK_IN");
      }}
    >
      Wyślij odprawę
    </AsyncLoadingButton>
  );
};

export default SendCheckInButton;
